var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21V15H15V21",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21V15H15V21",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72593 13H18.2804C18.6781 13 19 13.4939 19 14.1041V14.2494C19 15.77 18.1983 17 17.2073 17H8.79274C7.80168 17 7 15.77 7 14.2494V14.1041C7 13.4939 7.32194 13 7.71962 13H7.72593Z",
    fill: "white",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0959 3.29285H1.91059C1.49513 3.29285 1.15833 3.62965 1.15833 4.04512V12.9866C1.15833 13.402 1.49513 13.7388 1.91059 13.7388H24.0959C24.5114 13.7388 24.8482 13.402 24.8482 12.9866V4.04512C24.8482 3.62965 24.5114 3.29285 24.0959 3.29285Z",
    fill: "white",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74866 3.29283V1.13501",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91004 0H1.59385C1.35332 0 1.15833 0.194991 1.15833 0.435524V1.01622C1.15833 1.25676 1.35332 1.45175 1.59385 1.45175H3.91004C4.15058 1.45175 4.34557 1.25676 4.34557 1.01622V0.435524C4.34557 0.194991 4.15058 0 3.91004 0Z",
    fill: "#5B5E5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9315 3.29283V1.13501",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0929 0H20.7767C20.5362 0 20.3412 0.194991 20.3412 0.435524V1.01622C20.3412 1.25676 20.5362 1.45175 20.7767 1.45175H23.0929C23.3334 1.45175 23.5284 1.25676 23.5284 1.01622V0.435524C23.5284 0.194991 23.3334 0 23.0929 0Z",
    fill: "#5B5E5D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0033 3.29283V1.13501",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1581 0H11.8419C11.6014 0 11.4064 0.194991 11.4064 0.435524V1.01622C11.4064 1.25676 11.6014 1.45175 11.8419 1.45175H14.1581C14.3986 1.45175 14.5936 1.25676 14.5936 1.01622V0.435524C14.5936 0.194991 14.3986 0 14.1581 0Z",
    fill: "#5B5E5D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87598 3.29283V1.13501",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03077 0H6.71458C6.47404 0 6.27905 0.194991 6.27905 0.435524V1.01622C6.27905 1.25676 6.47404 1.45175 6.71458 1.45175H9.03077C9.2713 1.45175 9.46629 1.25676 9.46629 1.01622V0.435524C9.46629 0.194991 9.2713 0 9.03077 0Z",
    fill: "#5B5E5D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4641 3.29283V1.13501",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6255 0H16.3093C16.0688 0 15.8738 0.194991 15.8738 0.435524V1.01622C15.8738 1.25676 16.0688 1.45175 16.3093 1.45175H18.6255C18.866 1.45175 19.061 1.25676 19.061 1.01622V0.435524C19.061 0.194991 18.866 0 18.6255 0Z",
    fill: "#5B5E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillboardIcon);
export default __webpack_public_path__ + "static/media/Billboard-icon.3b08acf79a966932c2bd138e1c6c15af.svg";
export { ForwardRef as ReactComponent };